var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamic-image-icon"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":_vm.alt}}),_c('p',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }